import type { LangMap } from "./index";

const quotesIt: { text: string; bold: string }[] = [
  { text: "Concentrati su {b}. Piccoli passi, ogni giorno.", bold: "una materia alla volta" },
  { text: "La costanza batte {b}. Anche oggi, un po'.", bold: "il talento" },
  { text: "Non devi essere perfetto, devi {b}.", bold: "essere presente" },
  { text: "Studiare 20 minuti oggi vale più di {b} domani.", bold: "3 ore" },
  { text: "Ogni pagina letta è {b} verso il tuo obiettivo.", bold: "un passo" },
  { text: "Il cervello impara meglio quando {b}.", bold: "sei rilassato" },
  { text: "Fatto è meglio di {b}.", bold: "perfetto" },
  { text: "Ripeti a voce alta: ricordare è {b}.", bold: "un muscolo" },
  { text: "Prima il difficile, poi {b}.", bold: "il resto scorre" },
  { text: "Una pausa vera vale {b}.", bold: "quanto lo studio" },
  { text: "Sbagliare oggi è {b} domani.", bold: "imparare" },
  { text: "Chiediti: qual è {b} da fare adesso?", bold: "la cosa più importante" },
  { text: "Il tuo ritmo è {b}, non quello degli altri.", bold: "quello giusto" },
  { text: "Riassumi con parole tue: capire è {b}.", bold: "tradurre" },
  { text: "Un piccolo obiettivo chiaro vale più di {b}.", bold: "mille buoni propositi" },
  { text: "Respira. Sei {b} di quanto pensi.", bold: "più avanti" },
  { text: "Studiare bene è {b}, non più a lungo.", bold: "studiare meglio" },
  { text: "Le mappe mentali trasformano {b} in immagini.", bold: "le parole" },
  { text: "Domande migliori portano a {b}.", bold: "risposte migliori" },
  { text: "Oggi conta {b}, non la quantità.", bold: "la qualità" },
  { text: "Ricorda: il progresso è {b}, non una linea retta.", bold: "una spirale" },
  { text: "Trasforma il 'devo' in {b}.", bold: "'scelgo di'" },
  { text: "Il silenzio è {b} della concentrazione.", bold: "il miglior alleato" },
  { text: "Fissa un timer: 25 minuti valgono {b}.", bold: "una vittoria" },
  { text: "Rileggi con la matita in mano: attivo batte {b}.", bold: "passivo" },
  { text: "Chi dorme abbastanza {b} il doppio.", bold: "impara" },
  { text: "Un buon ripasso è {b} di uno studio nuovo.", bold: "più efficace" },
  { text: "Cerca il perché: capire batte {b}.", bold: "memorizzare" },
  { text: "Festeggia le piccole vittorie: {b} nasce lì.", bold: "la motivazione" },
  { text: "Domani ringrazierai il te di oggi per {b}.", bold: "aver iniziato" },
  { text: "Anche 10 minuti sono {b}.", bold: "un inizio" },
];

const quotesEn: { text: string; bold: string }[] = [
  { text: "Focus on {b}. Small steps, every day.", bold: "one subject at a time" },
  { text: "Consistency beats {b}. Even today, a little.", bold: "talent" },
  { text: "You don't have to be perfect, you have to {b}.", bold: "show up" },
  { text: "Studying 20 minutes today is worth more than {b} tomorrow.", bold: "3 hours" },
  { text: "Every page read is {b} toward your goal.", bold: "a step" },
  { text: "The brain learns best when {b}.", bold: "you're relaxed" },
  { text: "Done is better than {b}.", bold: "perfect" },
  { text: "Say it out loud: remembering is {b}.", bold: "a muscle" },
  { text: "Do the hard part first, then {b}.", bold: "the rest flows" },
  { text: "A real break is worth {b}.", bold: "as much as studying" },
  { text: "Making mistakes today is {b} tomorrow.", bold: "learning" },
  { text: "Ask yourself: what's {b} to do right now?", bold: "the most important thing" },
  { text: "Your pace is {b}, not someone else's.", bold: "the right one" },
  { text: "Summarize in your own words: understanding is {b}.", bold: "translating" },
  { text: "One small clear goal is worth more than {b}.", bold: "a thousand resolutions" },
  { text: "Breathe. You're {b} than you think.", bold: "further along" },
  { text: "Studying well means {b}, not longer.", bold: "studying smarter" },
  { text: "Mind maps turn {b} into images.", bold: "words" },
  { text: "Better questions lead to {b}.", bold: "better answers" },
  { text: "Today {b} counts, not quantity.", bold: "quality" },
  { text: "Remember: progress is {b}, not a straight line.", bold: "a spiral" },
  { text: "Turn 'I have to' into {b}.", bold: "'I choose to'" },
  { text: "Silence is {b} of concentration.", bold: "the best ally" },
  { text: "Set a timer: 25 minutes are worth {b}.", bold: "a win" },
  { text: "Reread pencil in hand: active beats {b}.", bold: "passive" },
  { text: "Those who sleep enough learn {b}.", bold: "twice as much" },
  { text: "A good review is {b} than fresh study.", bold: "more effective" },
  { text: "Look for the why: understanding beats {b}.", bold: "memorizing" },
  { text: "Celebrate small wins: {b} is born there.", bold: "motivation" },
  { text: "Tomorrow you'll thank today's you for {b}.", bold: "getting started" },
  { text: "Even 10 minutes is {b}.", bold: "a start" },
];

const quotesEs: { text: string; bold: string }[] = [
  { text: "Concéntrate en {b}. Pequeños pasos, cada día.", bold: "una materia a la vez" },
  { text: "La constancia vence al {b}. Incluso hoy, un poco.", bold: "talento" },
  { text: "No tienes que ser perfecto, tienes que {b}.", bold: "estar presente" },
  { text: "Estudiar 20 minutos hoy vale más que {b} mañana.", bold: "3 horas" },
  { text: "Cada página leída es {b} hacia tu objetivo.", bold: "un paso" },
  { text: "El cerebro aprende mejor cuando {b}.", bold: "estás relajado" },
  { text: "Hecho es mejor que {b}.", bold: "perfecto" },
  { text: "Repite en voz alta: recordar es {b}.", bold: "un músculo" },
  { text: "Primero lo difícil, luego {b}.", bold: "el resto fluye" },
  { text: "Una pausa real vale {b}.", bold: "tanto como estudiar" },
  { text: "Equivocarse hoy es {b} mañana.", bold: "aprender" },
  { text: "Pregúntate: ¿cuál es {b} que hacer ahora?", bold: "lo más importante" },
  { text: "Tu ritmo es {b}, no el de los demás.", bold: "el correcto" },
  { text: "Resume con tus palabras: entender es {b}.", bold: "traducir" },
  { text: "Un pequeño objetivo claro vale más que {b}.", bold: "mil buenos propósitos" },
  { text: "Respira. Estás {b} de lo que crees.", bold: "más avanzado" },
  { text: "Estudiar bien es {b}, no más tiempo.", bold: "estudiar mejor" },
  { text: "Los mapas mentales transforman {b} en imágenes.", bold: "las palabras" },
  { text: "Mejores preguntas llevan a {b}.", bold: "mejores respuestas" },
  { text: "Hoy cuenta {b}, no la cantidad.", bold: "la calidad" },
  { text: "Recuerda: el progreso es {b}, no una línea recta.", bold: "una espiral" },
  { text: "Convierte el 'debo' en {b}.", bold: "'elijo'" },
  { text: "El silencio es {b} de la concentración.", bold: "el mejor aliado" },
  { text: "Pon un temporizador: 25 minutos valen {b}.", bold: "una victoria" },
  { text: "Relee lápiz en mano: activo vence a {b}.", bold: "pasivo" },
  { text: "Quien duerme lo suficiente aprende {b}.", bold: "el doble" },
  { text: "Un buen repaso es {b} que un estudio nuevo.", bold: "más eficaz" },
  { text: "Busca el porqué: entender vence a {b}.", bold: "memorizar" },
  { text: "Celebra las pequeñas victorias: ahí nace {b}.", bold: "la motivación" },
  { text: "Mañana agradecerás al tú de hoy por {b}.", bold: "haber empezado" },
  { text: "Incluso 10 minutos son {b}.", bold: "un comienzo" },
];

const quotesFr: { text: string; bold: string }[] = [
  { text: "Concentre-toi sur {b}. Petits pas, chaque jour.", bold: "une matière à la fois" },
  { text: "La constance bat {b}. Même aujourd'hui, un peu.", bold: "le talent" },
  { text: "Tu n'as pas besoin d'être parfait, tu dois {b}.", bold: "être présent" },
  { text: "Étudier 20 minutes aujourd'hui vaut plus que {b} demain.", bold: "3 heures" },
  { text: "Chaque page lue est {b} vers ton objectif.", bold: "un pas" },
  { text: "Le cerveau apprend mieux quand {b}.", bold: "tu es détendu" },
  { text: "Fait vaut mieux que {b}.", bold: "parfait" },
  { text: "Répète à voix haute : se souvenir est {b}.", bold: "un muscle" },
  { text: "D'abord le difficile, puis {b}.", bold: "le reste coule" },
  { text: "Une vraie pause vaut {b}.", bold: "autant que l'étude" },
  { text: "Se tromper aujourd'hui, c'est {b} demain.", bold: "apprendre" },
  { text: "Demande-toi : quelle est {b} à faire maintenant ?", bold: "la chose la plus importante" },
  { text: "Ton rythme est {b}, pas celui des autres.", bold: "le bon" },
  { text: "Résume avec tes mots : comprendre, c'est {b}.", bold: "traduire" },
  { text: "Un petit objectif clair vaut plus que {b}.", bold: "mille bonnes résolutions" },
  { text: "Respire. Tu es {b} que tu ne le penses.", bold: "plus avancé" },
  { text: "Bien étudier, c'est {b}, pas plus longtemps.", bold: "étudier mieux" },
  { text: "Les cartes mentales transforment {b} en images.", bold: "les mots" },
  { text: "De meilleures questions mènent à {b}.", bold: "de meilleures réponses" },
  { text: "Aujourd'hui compte {b}, pas la quantité.", bold: "la qualité" },
  { text: "Rappelle-toi : le progrès est {b}, pas une ligne droite.", bold: "une spirale" },
  { text: "Transforme le 'je dois' en {b}.", bold: "'je choisis de'" },
  { text: "Le silence est {b} de la concentration.", bold: "le meilleur allié" },
  { text: "Mets un minuteur : 25 minutes valent {b}.", bold: "une victoire" },
  { text: "Relis crayon en main : actif bat {b}.", bold: "passif" },
  { text: "Qui dort assez apprend {b}.", bold: "deux fois plus" },
  { text: "Une bonne révision est {b} qu'une nouvelle étude.", bold: "plus efficace" },
  { text: "Cherche le pourquoi : comprendre bat {b}.", bold: "mémoriser" },
  { text: "Célèbre les petites victoires : {b} naît là.", bold: "la motivation" },
  { text: "Demain tu remercieras le toi d'aujourd'hui pour {b}.", bold: "avoir commencé" },
  { text: "Même 10 minutes sont {b}.", bold: "un début" },
];

const quotesDe: { text: string; bold: string }[] = [
  { text: "Konzentriere dich auf {b}. Kleine Schritte, jeden Tag.", bold: "ein Fach nach dem anderen" },
  { text: "Beständigkeit schlägt {b}. Auch heute, ein bisschen.", bold: "Talent" },
  { text: "Du musst nicht perfekt sein, du musst {b}.", bold: "präsent sein" },
  { text: "20 Minuten heute lernen ist mehr wert als {b} morgen.", bold: "3 Stunden" },
  { text: "Jede gelesene Seite ist {b} zu deinem Ziel.", bold: "ein Schritt" },
  { text: "Das Gehirn lernt am besten, wenn {b}.", bold: "du entspannt bist" },
  { text: "Erledigt ist besser als {b}.", bold: "perfekt" },
  { text: "Sag es laut: Erinnern ist {b}.", bold: "ein Muskel" },
  { text: "Erst das Schwere, dann {b}.", bold: "läuft der Rest von selbst" },
  { text: "Eine echte Pause ist {b} wert.", bold: "genauso viel wie Lernen" },
  { text: "Heute Fehler machen heißt morgen {b}.", bold: "lernen" },
  { text: "Frag dich: Was ist {b}, das jetzt zu tun ist?", bold: "das Wichtigste" },
  { text: "Dein Tempo ist {b}, nicht das der anderen.", bold: "das richtige" },
  { text: "Fasse mit eigenen Worten zusammen: Verstehen heißt {b}.", bold: "übersetzen" },
  { text: "Ein kleines klares Ziel ist mehr wert als {b}.", bold: "tausend gute Vorsätze" },
  { text: "Atme. Du bist {b}, als du denkst.", bold: "weiter" },
  { text: "Gut lernen heißt {b}, nicht länger.", bold: "besser lernen" },
  { text: "Mindmaps verwandeln {b} in Bilder.", bold: "Worte" },
  { text: "Bessere Fragen führen zu {b}.", bold: "besseren Antworten" },
  { text: "Heute zählt {b}, nicht die Menge.", bold: "die Qualität" },
  { text: "Denk daran: Fortschritt ist {b}, keine gerade Linie.", bold: "eine Spirale" },
  { text: "Verwandle das 'ich muss' in {b}.", bold: "'ich entscheide mich'" },
  { text: "Stille ist {b} der Konzentration.", bold: "der beste Verbündete" },
  { text: "Stell einen Timer: 25 Minuten sind {b} wert.", bold: "ein Sieg" },
  { text: "Lies mit dem Stift in der Hand erneut: aktiv schlägt {b}.", bold: "passiv" },
  { text: "Wer genug schläft, lernt {b}.", bold: "doppelt so viel" },
  { text: "Eine gute Wiederholung ist {b} als neuer Stoff.", bold: "effektiver" },
  { text: "Suche das Warum: Verstehen schlägt {b}.", bold: "auswendig lernen" },
  { text: "Feiere kleine Siege: dort entsteht {b}.", bold: "Motivation" },
  { text: "Morgen wirst du dem heutigen Ich für {b} danken.", bold: "den Anfang" },
  { text: "Auch 10 Minuten sind {b}.", bold: "ein Anfang" },
];

const quotesPt: { text: string; bold: string }[] = [
  { text: "Concentre-se em {b}. Pequenos passos, todos os dias.", bold: "uma matéria de cada vez" },
  { text: "A constância vence {b}. Mesmo hoje, um pouco.", bold: "o talento" },
  { text: "Você não precisa ser perfeito, precisa {b}.", bold: "estar presente" },
  { text: "Estudar 20 minutos hoje vale mais que {b} amanhã.", bold: "3 horas" },
  { text: "Cada página lida é {b} rumo ao seu objetivo.", bold: "um passo" },
  { text: "O cérebro aprende melhor quando {b}.", bold: "você está relaxado" },
  { text: "Feito é melhor que {b}.", bold: "perfeito" },
  { text: "Repita em voz alta: lembrar é {b}.", bold: "um músculo" },
  { text: "Primeiro o difícil, depois {b}.", bold: "o resto flui" },
  { text: "Uma pausa de verdade vale {b}.", bold: "tanto quanto estudar" },
  { text: "Errar hoje é {b} amanhã.", bold: "aprender" },
  { text: "Pergunte-se: qual é {b} a fazer agora?", bold: "a coisa mais importante" },
  { text: "Seu ritmo é {b}, não o dos outros.", bold: "o certo" },
  { text: "Resuma com suas palavras: entender é {b}.", bold: "traduzir" },
  { text: "Um pequeno objetivo claro vale mais que {b}.", bold: "mil boas intenções" },
  { text: "Respire. Você está {b} do que pensa.", bold: "mais avançado" },
  { text: "Estudar bem é {b}, não por mais tempo.", bold: "estudar melhor" },
  { text: "Mapas mentais transformam {b} em imagens.", bold: "as palavras" },
  { text: "Perguntas melhores levam a {b}.", bold: "respostas melhores" },
  { text: "Hoje conta {b}, não a quantidade.", bold: "a qualidade" },
  { text: "Lembre-se: o progresso é {b}, não uma linha reta.", bold: "uma espiral" },
  { text: "Transforme o 'tenho que' em {b}.", bold: "'eu escolho'" },
  { text: "O silêncio é {b} da concentração.", bold: "o melhor aliado" },
  { text: "Marque um cronômetro: 25 minutos valem {b}.", bold: "uma vitória" },
  { text: "Releia com o lápis na mão: ativo vence {b}.", bold: "passivo" },
  { text: "Quem dorme o suficiente aprende {b}.", bold: "o dobro" },
  { text: "Uma boa revisão é {b} que um estudo novo.", bold: "mais eficaz" },
  { text: "Busque o porquê: entender vence {b}.", bold: "memorizar" },
  { text: "Comemore pequenas vitórias: {b} nasce ali.", bold: "a motivação" },
  { text: "Amanhã você agradecerá ao você de hoje por {b}.", bold: "ter começado" },
  { text: "Mesmo 10 minutos são {b}.", bold: "um começo" },
];

function quotesToKeys(list: { text: string; bold: string }[]) {
  const out: Record<string, unknown> = {};
  list.forEach((q, i) => { out[String(i)] = q; });
  return out;
}

export const home: LangMap = {
  en: {
    greeting: { night: "Good night", morning: "Good morning", afternoon: "Good afternoon", evening: "Good evening" },
    title: "Your study today, {{name}} ✦",
    defaultStudent: "student",
    streakDays_one: "{{count}} day streak",
    streakDays_other: "{{count}} days streak",
    dailyGoal: "Today's goal",
    session: "Session",
    startStudying: "Start studying",
    studyTools: "Study tools",
    sections: { study: "Study & understand", create: "Create materials", review: "Review & test", plan: "Plan & progress" },
    cards: {
      ai: { title: "AI Tutor", sub: "Ask anything" },
      tools: { title: "Podcasts & Maps", sub: "Listen or visualize" },
      flashcards: { title: "Flashcards", sub: "Spaced review" },
      quiz: { title: "AI Quiz", sub: "Test yourself" },
      learn: { title: "Learn", sub: "Methods & mindset" },
      stats: { title: "Statistics", sub: "Level {{level}}" },
    },
    tip: {
      title: "Lumen's tip",
      body: { pre: "Try ", bold: "Active Recall", post: ": close the book, explain out loud what you read. It helps you cement concepts up to 4× faster." },
      cta: "Discover the method →",
    },
    quotes: quotesToKeys(quotesEn),
  },
  it: {
    greeting: { night: "Buona notte", morning: "Buongiorno", afternoon: "Buon pomeriggio", evening: "Buonasera" },
    title: "Il tuo studio di oggi, {{name}} ✦",
    defaultStudent: "studente",
    streakDays_one: "{{count}} giorno di streak",
    streakDays_other: "{{count}} giorni di streak",
    dailyGoal: "Obiettivo di oggi",
    session: "Sessione",
    startStudying: "Inizia a studiare",
    studyTools: "Strumenti di studio",
    sections: { study: "Studia e capisci", create: "Crea materiali", review: "Ripassa e verifica", plan: "Pianifica e progressi" },
    cards: {
      ai: { title: "Tutor AI", sub: "Chiedi qualsiasi cosa" },
      tools: { title: "Podcast & Mappe", sub: "Ascolta o visualizza" },
      flashcards: { title: "Flashcard", sub: "Ripasso spaziato" },
      quiz: { title: "Quiz IA", sub: "Mettiti alla prova" },
      learn: { title: "Imparare", sub: "Metodi & mente" },
      stats: { title: "Statistiche", sub: "Livello {{level}}" },
    },
    tip: {
      title: "Il consiglio di Lumen",
      body: { pre: "Prova la ", bold: "Active Recall", post: ": chiudi il libro, spiega ad alta voce ciò che hai letto. Ti aiuta a fissare i concetti fino a 4× più velocemente." },
      cta: "Scopri il metodo →",
    },
    quotes: quotesToKeys(quotesIt),
  },
  es: {
    greeting: { night: "Buenas noches", morning: "Buenos días", afternoon: "Buenas tardes", evening: "Buenas noches" },
    title: "Tu estudio de hoy, {{name}} ✦",
    defaultStudent: "estudiante",
    streakDays_one: "{{count}} día de racha",
    streakDays_other: "{{count}} días de racha",
    dailyGoal: "Objetivo de hoy",
    session: "Sesión",
    startStudying: "Empezar a estudiar",
    studyTools: "Herramientas de estudio",
    sections: { study: "Estudia y comprende", create: "Crea materiales", review: "Repasa y evalúa", plan: "Planifica y progreso" },
    cards: {
      ai: { title: "Tutor IA", sub: "Pregunta lo que quieras" },
      tools: { title: "Podcasts y Mapas", sub: "Escucha o visualiza" },
      flashcards: { title: "Tarjetas", sub: "Repaso espaciado" },
      quiz: { title: "Quiz IA", sub: "Ponte a prueba" },
      learn: { title: "Aprender", sub: "Métodos y mentalidad" },
      stats: { title: "Estadísticas", sub: "Nivel {{level}}" },
    },
    tip: {
      title: "El consejo de Lumen",
      body: { pre: "Prueba el ", bold: "Recuerdo Activo", post: ": cierra el libro, explica en voz alta lo que leíste. Te ayuda a fijar los conceptos hasta 4× más rápido." },
      cta: "Descubre el método →",
    },
    quotes: quotesToKeys(quotesEs),
  },
  fr: {
    greeting: { night: "Bonne nuit", morning: "Bonjour", afternoon: "Bon après-midi", evening: "Bonsoir" },
    title: "Ton étude d'aujourd'hui, {{name}} ✦",
    defaultStudent: "étudiant",
    streakDays_one: "{{count}} jour de série",
    streakDays_other: "{{count}} jours de série",
    dailyGoal: "Objectif du jour",
    session: "Session",
    startStudying: "Commencer à étudier",
    studyTools: "Outils d'étude",
    sections: { study: "Étudier et comprendre", create: "Créer des supports", review: "Réviser et tester", plan: "Planifier et progresser" },
    cards: {
      ai: { title: "Tuteur IA", sub: "Demande n'importe quoi" },
      tools: { title: "Podcasts & Cartes", sub: "Écoute ou visualise" },
      flashcards: { title: "Cartes mémo", sub: "Révision espacée" },
      quiz: { title: "Quiz IA", sub: "Teste-toi" },
      learn: { title: "Apprendre", sub: "Méthodes & mental" },
      stats: { title: "Statistiques", sub: "Niveau {{level}}" },
    },
    tip: {
      title: "Le conseil de Lumen",
      body: { pre: "Essaie le ", bold: "rappel actif", post: " : ferme le livre, explique à voix haute ce que tu as lu. Cela aide à ancrer les concepts jusqu'à 4× plus vite." },
      cta: "Découvre la méthode →",
    },
    quotes: quotesToKeys(quotesFr),
  },
  de: {
    greeting: { night: "Gute Nacht", morning: "Guten Morgen", afternoon: "Guten Tag", evening: "Guten Abend" },
    title: "Dein Studium heute, {{name}} ✦",
    defaultStudent: "Student",
    streakDays_one: "{{count}} Tag Serie",
    streakDays_other: "{{count}} Tage Serie",
    dailyGoal: "Heutiges Ziel",
    session: "Sitzung",
    startStudying: "Mit dem Lernen beginnen",
    studyTools: "Lernwerkzeuge",
    sections: { study: "Lernen und verstehen", create: "Materialien erstellen", review: "Wiederholen und testen", plan: "Planen und Fortschritt" },
    cards: {
      ai: { title: "KI-Tutor", sub: "Frag alles" },
      tools: { title: "Podcasts & Karten", sub: "Hören oder visualisieren" },
      flashcards: { title: "Karteikarten", sub: "Verteilte Wiederholung" },
      quiz: { title: "KI-Quiz", sub: "Teste dich selbst" },
      learn: { title: "Lernen", sub: "Methoden & Mentalität" },
      stats: { title: "Statistiken", sub: "Stufe {{level}}" },
    },
    tip: {
      title: "Lumens Tipp",
      body: { pre: "Probiere ", bold: "Active Recall", post: ": Schließe das Buch und erkläre laut, was du gelesen hast. Es hilft, Konzepte bis zu 4× schneller zu festigen." },
      cta: "Entdecke die Methode →",
    },
    quotes: quotesToKeys(quotesDe),
  },
  pt: {
    greeting: { night: "Boa noite", morning: "Bom dia", afternoon: "Boa tarde", evening: "Boa noite" },
    title: "Seu estudo de hoje, {{name}} ✦",
    defaultStudent: "estudante",
    streakDays_one: "{{count}} dia de sequência",
    streakDays_other: "{{count}} dias de sequência",
    dailyGoal: "Objetivo de hoje",
    session: "Sessão",
    startStudying: "Começar a estudar",
    studyTools: "Ferramentas de estudo",
    sections: { study: "Estuda e compreende", create: "Cria materiais", review: "Revê e testa", plan: "Planeia e progresso" },
    cards: {
      ai: { title: "Tutor IA", sub: "Pergunte qualquer coisa" },
      tools: { title: "Podcasts & Mapas", sub: "Ouça ou visualize" },
      flashcards: { title: "Flashcards", sub: "Revisão espaçada" },
      quiz: { title: "Quiz IA", sub: "Coloque-se à prova" },
      learn: { title: "Aprender", sub: "Métodos & mentalidade" },
      stats: { title: "Estatísticas", sub: "Nível {{level}}" },
    },
    tip: {
      title: "A dica do Lumen",
      body: { pre: "Experimente a ", bold: "Recuperação Ativa", post: ": feche o livro e explique em voz alta o que leu. Isso ajuda a fixar os conceitos até 4× mais rápido." },
      cta: "Descubra o método →",
    },
    quotes: quotesToKeys(quotesPt),
  },
};
